export default "__VITE_ASSET__BGlrYSvb__"